<template>
  <v-container class="mt-2 mr-2" fluid>
    <v-row>
      
			<v-col cols="12">
        <!-- Buscador -->
        <v-card-title primary-title>

          <v-spacer></v-spacer>
          
          <!-- Agregar un artículo nuevo -->
          <v-dialog v-model="dialog" class="mt-6" persistent max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                @click="nuevo"
                tile
                small
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-btn 
                color="primary" small absolute right top fab 
                @click="dialog= false, fotosCargadas = []" class="mt-8">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <!-- Carda para visualizar datos o aregar un artículos nuevo -->
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-card-title primary-title>
                       <div v-if="modo == 1">Nuevo Artículo</div>
                       <div v-else>Editar Artículo</div>
                    </v-card-title>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="8" class="mb-0">
                      <v-text-field 
                        v-model="editedItem.nomart" 
                        label="Nombre"
                        hide-details 
                        dense
                        filled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="mb-0">
                      <v-text-field 
                        v-model="editedItem.precio" 
                        label="Precio" 
                        type="number" 
                        hide-details
                        dense
                        filled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12"  class="mb-0">
                      <v-textarea 
                        v-model="editedItem.notas" 
                        label="Notas" 
                        dense
                        filled
                      >
                      </v-textarea>
                    </v-col>
                    <v-col cols="12" >
                      <v-file-input
                        multiple
                        dense
                        filled
                        accept="image/png, image/jpeg, image/bmp"
                        placeholder="Agrega una imagen"
                        prepend-icon="mdi-camera"
                        label="Imágenes"
                        @change="cargarFotos()"
                        v-model="files"
                      ></v-file-input>
                    </v-col>

                    <!-- Mostrar fotos ya grabas del artículo -->
                    <v-col cols="12" lg="3" align="left" 
                      v-if="editedItem.imagename[0].imagename != ''"
                      v-for="(foto, i) in editedItem.imagename" 
                      :key="i">
                      <v-card class="elevation-12">
                        <v-img :src="url + foto.imagename" contain width="100%" max-height="150"/>
                        <v-btn 
                          color="secondary" dark absolute right top small fab
                          @click="eliminarFoto(foto,i)">
                          <v-icon >mdi-delete</v-icon>
                        </v-btn>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- Visualizar las fotos cargadas si es que hay -->
                  <v-row v-if="fotosCargadas.length > 0">
                    <v-col cols="12" lg="3" align="left" v-for="(foto, i) in fotosCargadas" :key="i">
                      <v-card class="elevation-12">
                        <v-img :src="foto.foto" contain width="100%" max-height="150"/>
                        <v-btn 
                          color="secondary" dark absolute right top small fab
                          @click="eliminarFotoCargada(i)">
                          <v-icon >mdi-delete</v-icon>
                        </v-btn>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="black"
                  dark
                  small
                  @click="close"
                  tile
                  dense
                >
                  <v-icon left small>mdi-close</v-icon>
                  Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  small
                  dark
                  @click="save"
                  tile
                >
                  <v-icon left small>mdi-content-save</v-icon>
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn  class="orange ml-2" small tile dark @click="initialize" ><v-icon>mdi-refresh</v-icon> </v-btn>

        </v-card-title>

        <v-card-text>
          <v-row justify="end">
            <v-col cols="12" md="6">
              <v-text-field
                dense
                filled
                single-line
                hide-details
                label="Búscar"
                v-model="search"
                append-icon="mdi-magnfy"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
			</v-col>

      <!-- Catalago en forma de carts -->
      <v-col cols="12" xl="4" lg="6" sm="6"  v-for="(a, i) in filterArticulos" :key="i">
        <!-- Articulos -->
        <v-card class="ma-2 elevation-12">
          <v-row>
            <v-col cols="12" md="6">
              <v-carousel
                v-if="a.imagename[0].imagename != ''"
                cycle
                height="200"
                hide-delimiter-background
                show-arrows-on-hover
              >
                <v-carousel-item
                  v-for="(image, i) in a.imagename"
                  :key="i"
                >
                  <v-img 
                    :src="url + image.imagename" 
                    height="200" contain/>
                </v-carousel-item>
              </v-carousel>
              <v-img src="@/assets/blanco.jpg" height="200" contain v-else/>
              <v-divider></v-divider>
              <v-card-text align="center">
                <b>{{a.nomart}}</b><br/>
                ${{a.precio}} MXN<br/>
                <div v-if="a.notas.length > 50">{{a.notas.substr(0,50)}}...</div>
                <div v-else   >{{a.notas}}</div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="6">
              <v-card-title primary-title>
                Categorías 
                <v-btn color="blue" icon @click="dialogAddCategoria = true, idSelectArt = a.idarticulo, getCat()"><v-icon>mdi-plus-circle</v-icon></v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-data-table
                :loading="loading"
                :headers="headersArt"
                :items="a.categorias"
                fixed-header
                :height="200"
                hide-default-footer
                loading-text="Cargando..."
                dense
                :items-per-page="100"
                :mobile-breakpoint="250"
                >
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="secondary"
                    small
                    @click="dialogDeleteCatego = true, idCatego = item.idartcatego"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                </v-card-title>
              </v-data-table>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small dark @click="editItem(a)" rounded>
              Editar<v-icon right>mdi-pencil</v-icon>
            </v-btn>
            <v-btn color="secondary"  small @click="dialogDeleteArt = true, idDelete = a.idarticulo" rounded>
              Eliminar<v-icon right>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
		</v-row>

    <!-- Eliminar un artículo -->
		<v-row justify="center">
      <v-dialog v-model="dialogDeleteArt" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Eliminar Artículo</v-card-title>
          <v-card-text>¿Deseas eliminar permanentemente el artículo?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogDeleteArt = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="deleteItem">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Eliminar la categoría de un articulo -->
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteCatego" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Eliminar Categoría</v-card-title>
          <v-card-text>¿Deseas eliminar permanentemente la categoría?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogDeleteCatego = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="deleteCatego">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Agregar categorías al artículo -->
    <v-row justify="center">
      <v-dialog v-model="dialogAddCategoria" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Agregar categoría</v-card-title>
          <v-card-text>
            <v-select 
              dense
              outlined
              :items="categorias"
              v-model="categoria"
              item-text="nomcatego"
              item-value="idcatego" 
              label="Categoría"
              persistent-hint
              single-line
              hide-details
              return-object
            ></v-select>
            {{mensaje}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogAddCategoria = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="agregarCatego">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'


  export default {
    components:{
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      // Alerta
      snackbar:false,
      color:'',
      mensaje:'',
      // modo
      modo: 1, // 1 nuevo, 2 editar,
      // Fotografía
      files:[],
      foto:'',
      formdata:'',
      url:'',
      fotosCargadas:[],

      // nuevo articulo
      dialog: false,
      editedIndex: -1,
      editedItem: {
      	idarticulo: 0,
        nomart: '',
        precio: 0,
        cant: 1,
        imagename:[],
        notas:'',
      },
      defaultItem: {
      	idarticulo: 0,
        nomart: '',
        precio: 0,
        cant: 1,
        imagename:[],
        notas:'',
      },

      idCatego:0,
      mensaje:'',
      dialogAddCategoria: false,
      dialogDeleteCatego:false,
    	loading:true,
    	idDelete: 0,
      idSelectArt:0,
      dialogDeleteArt: false,
      headers: [
        { text: 'Artículo', align: 'start', value: 'nomart'},
        { text: 'Precio', align: 'start', value: 'precio'},
        { text: 'Acciones', align: 'start', value: 'actions'},
      ],

      categorias:[],
      categoria:{idcatego:'', nomcatego:''},
      headersArt: [
        { text: 'Categoría', align: 'start', value: 'nomcatego'},
        { text: 'Acciones', align: 'end', value: 'actions'},
      ],

      articulos: [],
      search:'',
      longitud:100,
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo artículos' : 'Editar artículo'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },

      categoria(){
        this.mensaje = ''
        console.log(this.categoria)
      }
    },

    async created () {
      await this.initialize()
      this.url = this.$http.options.root + 'fotos/'
    },

    methods: {
      initialize () {
        this.articulos = []
        this.cargar = true
        this.$http.get('articulos.all').then(response=>{
        	this.articulos = response.body
        	this.longitud  = this.articulos.length
        	this.loading   = false
          this.cargar    = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      nuevo(){
        this.modo = 1
        console.log(this.modo)
      },

      editItem (item) {
        // Lo ponemos en modo editar
        this.modo = 2
        // Asignamos los valores a editar con el valor que recibimos
        this.editedItem = Object.assign({}, item)
        // Abrimos el cuadro de dialogo para editar y visualizar la información
        this.dialog = true
      },

      deleteItem () {
        this.$http.delete('articulo.delete/' + this.idDelete).then(response=>{
        	this.initialize()
          this.dialogDeleteArt = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        // le agregamos las fotos cargadas al objeto que vamos a grabar
        // Hacemos un arreglo de nombres de fotografías
        var payload = []
        for(const i in this.fotosCargadas){
          payload.push({imagename: this.fotosCargadas[i].imagename})
        }
        this.editedItem.imagename = payload
        
        this.cargar = true

        if (this.modo == 2) {
          // Hacemo un put para actualizar los datos
        	this.$http.put('articulo.update/' + this.editedItem.idarticulo, this.editedItem).then(response=>{
            this.mensaje = 'Artículo actualizado correctamente'
            this.color = 'success'
            this.snackbar = true
            this.close()
            // Si hay fotos, hay que guardarlas
            if(this.files.length > 0){
              this.cargar = false
              this.guardarFotos()
            }else{
              this.cargar = false
              this.initialize()
            }
	        }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        } else {
          // Realizamos un post para agregar el artículo
          this.$http.post('articulo.add', this.editedItem).then(response=>{
            this.mensaje = 'Artículo grabado correctamente'
            this.color = 'success'
            this.snackbar = true
            this.cargar = false
            this.close()
            this.guardarFotos()
	        }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }
      },

      guardarFotos(){
        // si hay fotos cargadas, hay que guardarlas
        if(this.fotosCargadas.length > 0){
          // Recorremos las fotos para guardarlas
          for(const i in this.fotosCargadas){
            // Hacemos un post para guardar las fotografías
            this.$http.post('imagenes', this.fotosCargadas[i].formdata).then(response=>{
              this.mensaje = 'Fotografías grabadas correctamente'
              this.color = 'success'
              this.snackbar = true
              this.editedItem.imagename = []
              this.files = []
              this.fotosCargadas = []
            }).catch(error=>{
              this.mensaje = 'Error al grabar fotografías'
              this.color = 'error'
              this.snackbar = true
              console.log(error)
            })
          }
          // Al terminar recgamos los artículos
          this.initialize()
        }else{
          this.initialize()
        }
      },

      getCat(){
        this.$http.get('clasificacion.all').then(response=>{
          this.categorias = response.body
        }).catch(error=>{console.log(error)})
      },

      agregarCatego(){
        var payload ={
          idarticulo: this.idSelectArt,
          idcatego: this.categoria.idcatego
        }
        this.$http.post('clasart.add',payload).then(response=>{
          this.mensaje = 'Categoría agregada'
          this.initialize()
        }).catch(error=>{console.log(error)})
      },

      deleteCatego(){
        this.$http.delete('clasart.delete/' + this.idCatego).then(response=>{
          this.initialize()
          this.dialogDeleteCatego = false
        }).catch(error=>console.log(error))
      },

      cargarFotos(){
        // Inicializamos las fotos cargadas en vacio
        this.fotosCargadas = []

        // Validamos que tenga una o más fotos cargadas
        if(this.files.length > 0){
          // Recorrmos las fotos cargadas
          for(const i in this.files){
            // creamos una variable tipo FormData
            let formData = new FormData();
            //se crea el objeto y se le agrega como un apendice el archivo 
            formData.append('file', this.files[i]);
            //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
            this.getBase64(this.files[i], formData, this.files[i].name)
          }
        }
      },

      getBase64(archivo,formData,name) {
        var me = this
        // Creamos la variable de lectura
        var reader = new FileReader();
        // leemos el archivos
        reader.readAsDataURL(archivo);
        reader.onload =  function(){
          // Agregamos la foto cargada al arreglo que vamos a mostrar arriba en la pantalla
          me.fotosCargadas.push({
            foto: reader.result,
            formdata: formData,
            imagename: name,
          })
        };
      },

      // Función para eliminar fotos agregadas eventualmente al artículo
      eliminarFotoCargada(value){
        this.fotosCargadas.splice(value,1)
        console.log(value)
      },

      // Eliminar foto ya cargada del artículo
      eliminarFoto(foto,i){
        console.log(foto)
        this.$http.post('foto.delete/' + foto.idfoto, foto).then(response=>{
          this.editedItem.imagename.splice(i,1)
          this.color = 'success'
          this.mensaje  = 'Foto eliminada correctamente'
          this.snackbar = true
          console.log(response.body)
        }).catch(error=>{
          this.editedItem.imagename.splice(i,1)
          this.color = 'error'
          this.mensaje  = 'ERROR al eliminar la foto'
          this.snackbar = true
        })
      }
    },

    computed:{

      filterArticulos: function(){
        var me = this
        if(this.articulos){
          return this.articulos.filter((art)=>{
            var nom = art.nomart.toLowerCase();
            return nom.match(this.search.toLowerCase());
          })
        }
      },
    }
  }
</script>

<style>

.v-data-table__wrapper{

}

.v-data-table__wrapper::-webkit-scrollbar {
    -webkit-appearance: none !important;
}

.v-data-table--fixed-header > .v-data-table__wrapper::-webkit-scrollbar:vertical {
  width:10px !important;
}

.v-data-table__wrapper::-webkit-scrollbar:vertical {
  width:10px !important;
}



.v-data-table__wrapper::-webkit-scrollbar:vertical {
    width:10px !important;
}

.v-data-table__wrapper::-webkit-scrollbar-button:increment,.v-data-table__wrapper::-webkit-scrollbar-button {
    display: none;
} 

.v-data-table__wrapper::-webkit-scrollbar:horizontal {
    height: 10px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb {
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ffffff;
}



</style>
